import React, { useContext, useEffect } from 'react';
import Button from '../../@base/Button';
import MentionsInput from '../../MentionsInput/MentionsInput';
import style from './Intent.module.css';
import WatsonContext from '../../../context/WatsonContext';

const info = (
  <div>
    Exemplo de treinamento:
    {' '}
    <i className="fa fa-info-circle fa-sm" title="Utilize @ para referenciar entidades" aria-hidden="true" />
  </div>
);

let entities = [];

export function IntentDetailAddExampleButton(props) {
  const addExampleButtonHandler = (e) => {
    props.setExample({
      ...props.example,
      text: e.target.value,
    });
  };

  const watsonContext = useContext(WatsonContext);
  useEffect(() => {
    if (watsonContext.entities) {
      entities = Object.values(watsonContext.entities);
      entities = entities.map((e) => ({ id: e.name, display: e.name }));
    }
  }, [watsonContext.entities]);

  return (
    <div className={`${style.AddExample} row`}>
      <div className="col-11">
        <MentionsInput
          label={info}
          placeholder="Exemplo de treinamento"
          value={props.example.text}
          onChange={addExampleButtonHandler}
          suggestions={entities}
          trigger="@"
        />
      </div>
      <div className="col-1">
        <Button
          circle
          primary
          small
          classes={style.ButtonAddExample}
          onClick={props.saveExample}
          disabled={props.example.text.trim().length === 0}
        >
          <small>
            <i className="fa fa-plus" aria-hidden="true" />
          </small>
        </Button>
      </div>
    </div>
  );
}

export default IntentDetailAddExampleButton;
